/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorPollSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PerformanceIndicatorPollSettings model module.
   * @module model/PerformanceIndicatorPollSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PerformanceIndicatorPollSettings</code>.
   * @alias module:model/PerformanceIndicatorPollSettings
   * @class
   */
  var exports = function() {
    var _this = this;


























  };

  /**
   * Constructs a <code>PerformanceIndicatorPollSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PerformanceIndicatorPollSettings} obj Optional instance to populate.
   * @return {module:model/PerformanceIndicatorPollSettings} The populated <code>PerformanceIndicatorPollSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatorUserID')) {
        obj['CreatorUserID'] = ApiClient.convertToType(data['CreatorUserID'], 'Integer');
      }
      if (data.hasOwnProperty('ValueAggregationTypeID')) {
        obj['ValueAggregationTypeID'] = ApiClient.convertToType(data['ValueAggregationTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('AggregateByFunction')) {
        obj['AggregateByFunction'] = ApiClient.convertToType(data['AggregateByFunction'], 'Integer');
      }
      if (data.hasOwnProperty('TargetUserFunctionID')) {
        obj['TargetUserFunctionID'] = ApiClient.convertToType(data['TargetUserFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('TargetUserID')) {
        obj['TargetUserID'] = ApiClient.convertToType(data['TargetUserID'], 'Integer');
      }
      if (data.hasOwnProperty('ValueTypeID')) {
        obj['ValueTypeID'] = ApiClient.convertToType(data['ValueTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('DimensionID')) {
        obj['DimensionID'] = ApiClient.convertToType(data['DimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('IntroductionText')) {
        obj['IntroductionText'] = ApiClient.convertToType(data['IntroductionText'], 'String');
      }
      if (data.hasOwnProperty('ScheduleStartDate')) {
        obj['ScheduleStartDate'] = ApiClient.convertToType(data['ScheduleStartDate'], 'Date');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('PeriodID')) {
        obj['PeriodID'] = ApiClient.convertToType(data['PeriodID'], 'Integer');
      }
      if (data.hasOwnProperty('NotificationSendingTimeTypeID')) {
        obj['NotificationSendingTimeTypeID'] = ApiClient.convertToType(data['NotificationSendingTimeTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('PerformanceIndicatorPeriodTypeID')) {
        obj['PerformanceIndicatorPeriodTypeID'] = ApiClient.convertToType(data['PerformanceIndicatorPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('CollectionTypeID')) {
        obj['CollectionTypeID'] = ApiClient.convertToType(data['CollectionTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('AnonymizeResults')) {
        obj['AnonymizeResults'] = ApiClient.convertToType(data['AnonymizeResults'], 'Boolean');
      }
      if (data.hasOwnProperty('SendToGenericRecipients')) {
        obj['SendToGenericRecipients'] = ApiClient.convertToType(data['SendToGenericRecipients'], 'Boolean');
      }
      if (data.hasOwnProperty('GenericRecipientAddresses')) {
        obj['GenericRecipientAddresses'] = ApiClient.convertToType(data['GenericRecipientAddresses'], 'String');
      }
      if (data.hasOwnProperty('SendToMicrosoftTeamsRecipients')) {
        obj['SendToMicrosoftTeamsRecipients'] = ApiClient.convertToType(data['SendToMicrosoftTeamsRecipients'], 'Boolean');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('ResponsibleUserID')) {
        obj['ResponsibleUserID'] = ApiClient.convertToType(data['ResponsibleUserID'], 'Integer');
      }
      if (data.hasOwnProperty('AccessibleByManagers')) {
        obj['AccessibleByManagers'] = ApiClient.convertToType(data['AccessibleByManagers'], 'Boolean');
      }
      if (data.hasOwnProperty('PollGroupID')) {
        obj['PollGroupID'] = ApiClient.convertToType(data['PollGroupID'], 'Integer');
      }
      if (data.hasOwnProperty('UseNetPromoterScoreAggregation')) {
        obj['UseNetPromoterScoreAggregation'] = ApiClient.convertToType(data['UseNetPromoterScoreAggregation'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {Integer} CreatorUserID
   * @default 0
   */
  exports.prototype['CreatorUserID'] = 0;
  /**
   * @member {Integer} ValueAggregationTypeID
   * @default 0
   */
  exports.prototype['ValueAggregationTypeID'] = 0;
  /**
   * @member {Integer} AggregateByFunction
   * @default 0
   */
  exports.prototype['AggregateByFunction'] = 0;
  /**
   * @member {Integer} TargetUserFunctionID
   */
  exports.prototype['TargetUserFunctionID'] = undefined;
  /**
   * @member {Integer} TargetUserID
   */
  exports.prototype['TargetUserID'] = undefined;
  /**
   * @member {Integer} ValueTypeID
   * @default 0
   */
  exports.prototype['ValueTypeID'] = 0;
  /**
   * @member {Integer} DimensionID
   * @default 0
   */
  exports.prototype['DimensionID'] = 0;
  /**
   * @member {String} IntroductionText
   * @default ''
   */
  exports.prototype['IntroductionText'] = '';
  /**
   * @member {Date} ScheduleStartDate
   */
  exports.prototype['ScheduleStartDate'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} PeriodID
   * @default 0
   */
  exports.prototype['PeriodID'] = 0;
  /**
   * @member {Integer} NotificationSendingTimeTypeID
   * @default 0
   */
  exports.prototype['NotificationSendingTimeTypeID'] = 0;
  /**
   * @member {Integer} PerformanceIndicatorPeriodTypeID
   * @default 0
   */
  exports.prototype['PerformanceIndicatorPeriodTypeID'] = 0;
  /**
   * @member {Integer} CollectionTypeID
   */
  exports.prototype['CollectionTypeID'] = undefined;
  /**
   * @member {Boolean} AnonymizeResults
   * @default false
   */
  exports.prototype['AnonymizeResults'] = false;
  /**
   * @member {Boolean} SendToGenericRecipients
   * @default false
   */
  exports.prototype['SendToGenericRecipients'] = false;
  /**
   * @member {String} GenericRecipientAddresses
   * @default ''
   */
  exports.prototype['GenericRecipientAddresses'] = '';
  /**
   * @member {Boolean} SendToMicrosoftTeamsRecipients
   * @default false
   */
  exports.prototype['SendToMicrosoftTeamsRecipients'] = false;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {Integer} ResponsibleUserID
   * @default 0
   */
  exports.prototype['ResponsibleUserID'] = 0;
  /**
   * @member {Boolean} AccessibleByManagers
   * @default false
   */
  exports.prototype['AccessibleByManagers'] = false;
  /**
   * @member {Integer} PollGroupID
   */
  exports.prototype['PollGroupID'] = undefined;
  /**
   * @member {Boolean} UseNetPromoterScoreAggregation
   * @default false
   */
  exports.prototype['UseNetPromoterScoreAggregation'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


